/** The one UUID shape every reasoning identity (command, run, session, source node) must have. */
export const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const isUuid = (value: string): boolean => UUID_PATTERN.test(value);

/** Matches ReasoningController.StableRequestId, including .NET Guid's byte order. */
export async function reasoningRequestIds(
  commandId: string,
): Promise<{ runId: string; sessionId: string }> {
  if (!isUuid(commandId)) throw new Error("A reasoning request needs a UUID command identity.");
  const id = async (purpose: string) => {
    const bytes = new Uint8Array(
      await crypto.subtle.digest(
        "SHA-256",
        new TextEncoder().encode(`reasoning-request/1:${commandId.toLowerCase()}:${purpose}`),
      ),
    ).slice(0, 16);
    bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x50;
    bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
    const hex = (indexes: number[]) =>
      indexes.map((i) => (bytes[i] ?? 0).toString(16).padStart(2, "0")).join("");
    return [
      hex([3, 2, 1, 0]),
      hex([5, 4]),
      hex([7, 6]),
      hex([8, 9]),
      hex([10, 11, 12, 13, 14, 15]),
    ].join("-");
  };
  const [runId, sessionId] = await Promise.all([id("run"), id("session")]);
  return { runId, sessionId };
}
